import React from 'react';
import { Landmark, Briefcase, HeartHandshake, Banknote } from 'lucide-react';
import { formatGold } from '../../utils/goldNotation';
import { formatBRL } from '../../utils/transparency';

const CARD_CLASS = 'bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl rounded-2xl p-5 border border-white/10 shadow-xl flex items-start gap-4';

// Saldos gerais do clã (não mudam com o seletor) + doações do recorte.
const BalanceCards = ({ balances, donatedAmount, scopeIsAll }) => {
  const cards = [
    { label: 'Caixa', value: formatGold(balances.caixa), exact: Number(balances.caixa).toLocaleString('pt-BR'), hint: 'Saldo atual', icon: Landmark, color: 'from-purple-500 to-fuchsia-600' },
    { label: 'Caixa Administrativo', value: formatGold(balances.administrativo), exact: Number(balances.administrativo).toLocaleString('pt-BR'), hint: 'Saldo atual', icon: Briefcase, color: 'from-orange-500 to-amber-600' },
    { label: 'Doações', value: formatGold(donatedAmount), exact: Number(donatedAmount).toLocaleString('pt-BR'), hint: scopeIsAll ? 'Em todos os BCs' : 'Neste BC', icon: HeartHandshake, color: 'from-pink-500 to-rose-600' },
    { label: 'Dinheiro', value: formatBRL(balances.real), exact: formatBRL(balances.real), hint: 'Saldo atual em reais', icon: Banknote, color: 'from-emerald-500 to-green-600' },
  ];

  return (
    <div className="space-y-3">
      <h2 className="text-xl font-bold text-white">Saldos do Clã</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(({ label, value, exact, hint, icon: Icon, color }) => (
          <div key={label} className={CARD_CLASS}>
            <div className={`p-3 rounded-xl bg-gradient-to-br ${color} shrink-0`}>
              <Icon className="w-6 h-6 text-white" />
            </div>
            <div className="min-w-0">
              <p className="text-gray-400 text-sm">{label}</p>
              <p className="text-2xl font-bold text-white" title={exact}>{value}</p>
              <p className="text-gray-500 text-xs mt-1">{hint}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BalanceCards;
